/**
 * App-level theme layered onto the resolved brand palette. These go through the design
 * library's `themeOverrides` prop — a second `ChakraProvider` would double every toast
 * and popover portal, and Modal's focus trap then hides the second one.
 *
 * Colour never appears here: the palette owns it in both modes.
 */
export const APP_THEME_OVERRIDES = {
  fonts: {
    body: "'Inter', system-ui, sans-serif",
    heading: "'Inter', system-ui, sans-serif"
  },
  components: {
    Button: { defaultProps: { size: 'sm' } },
    Input: { defaultProps: { size: 'sm' } },
    Select: { defaultProps: { size: 'sm' } },
    Textarea: { defaultProps: { size: 'sm' } }
  },
  zIndices: {
    // The command palette sits above the sidebar rail but below Chakra's modal layer.
    palette: 1300
  }
};
